import { notFoundSVGIcon} from './common';
import { SVGIconDetail, SVGIconWithoutValue, createSVGPath } from './icons';
import { getNumericObjectValues } from '../../../core/utils/general/general';


const highPriorityIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 1024,
  shapes: [
    createSVGPath(
      'M452.266667 955.733333l-384-384c-34.133333-34.133333-34.133333-87.466667 0-121.6l384-384c34.133333-34.133333 87.466667-34.133333 121.6 0l384 384c34.133333 34.133333 34.133333 87.466667 0 121.6l-384 384c-34.133333 34.133333-89.6 34.133333-121.6 0z'
    ),
    createSVGPath(
      'M460.8 697.6c0-6.4 2.133333-12.8 4.266667-19.2 2.133333-6.4 6.4-10.666667 10.666666-14.933333 4.266667-4.266667 10.666667-8.533333 17.066667-10.666667s12.8-4.266667 21.333333-4.266667 14.933333 2.133333 21.333334 4.266667c6.4 2.133333 12.8 6.4 17.066666 10.666667 4.266667 4.266667 8.533333 8.533333 10.666667 14.933333 2.133333 6.4 4.266667 12.8 4.266667 19.2s-2.133333 12.8-4.266667 19.2-6.4 10.666667-10.666667 14.933333c-4.266667 4.266667-10.666667 8.533333-17.066666 10.666667-6.4 2.133333-12.8 4.266667-21.333334 4.266667s-14.933333-2.133333-21.333333-4.266667-10.666667-6.4-17.066667-10.666667c-4.266667-4.266667-8.533333-8.533333-10.666666-14.933333s-4.266667-10.666667-4.266667-19.2z m89.6-98.133333h-76.8L462.933333 277.333333h98.133334l-10.666667 322.133334z',
      { fillOpposite: true }
    ),
  ],
});

const mediumPriorityIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 1024,
  shapes: [
    createSVGPath(
      'M452.266667 955.733333l-384-384c-34.133333-34.133333-34.133333-87.466667 0-121.6l384-384c34.133333-34.133333 87.466667-34.133333 121.6 0l384 384c34.133333 34.133333 34.133333 87.466667 0 121.6l-384 384c-34.133333 34.133333-89.6 34.133333-121.6 0z'
    ),
    createSVGPath(
      'M512 512m-42.666667 0a42.666667 42.666667 0 1 0 85.333334 0 42.666667 42.666667 0 1 0-85.333334 0Z',
      { fillOpposite: true }
    ),
    createSVGPath(
      'M682.666667 512m-42.666667 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z',
      { fillOpposite: true }
    ),
    createSVGPath(
      'M341.333333 512m-42.666666 0a42.666667 42.666667 0 1 0 85.333333 0 42.666667 42.666667 0 1 0-85.333333 0Z',
      { fillOpposite: true }
    ),
  ],
});

const lowPriorityIconDetail = (): SVGIconWithoutValue => ({
  viewBoxSize: 1024,
  shapes: [
    createSVGPath(
      'M452.266667 955.733333l-384-384c-34.133333-34.133333-34.133333-87.466667 0-121.6l384-384c34.133333-34.133333 87.466667-34.133333 121.6 0l384 384c34.133333 34.133333 34.133333 87.466667 0 121.6l-384 384c-34.133333 34.133333-89.6 34.133333-121.6 0z'
    ),
    createSVGPath('M512 712.533333L362.666667 533.333333h298.666666z', {
      fillOpposite: true,
    }),
    createSVGPath('M469.333333 315.733333h85.333334v262.4h-85.333334z', {
      fillOpposite: true,
    }),
  ],
});

export enum PriorityStatus {
  HighPriority = 1,
  MediumPriority = 2,
  LowPriority = 4,
}

const getPriorityIcon = (status: string | number) => {
  switch (status) {
    case PriorityStatus.HighPriority:
      return highPriorityIconDetail();
    case PriorityStatus.MediumPriority:
      return mediumPriorityIconDetail();
    case PriorityStatus.LowPriority:
      return lowPriorityIconDetail();
  }

  return notFoundSVGIcon();
};
export const getPriorityIconSet = (): SVGIconDetail[] =>
  getNumericObjectValues(PriorityStatus).map((value) => ({
    value,
    ...getPriorityIcon(value),
  }));